import PropTypes from 'prop-types';
import GridOptions from './GridOptions';
import MuiGrid from '../../../UI/MuiGrid/MuiGrid';
import { icons } from '../../../../../shared/icons';
import CheckBox from '../../../UI/FormControls/CheckBox';
import { useTranslation } from 'react-i18next';

const GridProvider = ({
  data,
  handleOpenDeleteDialog,
  handleEditData,
  isLoading,
  idKlijenta,
}) => {
  const { t, i18n } = useTranslation();
  const idFirme = localStorage.getItem('idFirme');
  const columns = [
    {
      field: 'id',
      disableExport: true,
      headerName: t('options'),
      width: 60,
      sortable: false,
      filterable: false,
      renderCell: (e) => (
        <GridOptions
          handleOpenDialog={() => handleOpenDeleteDialog(e.id)}
          getEditData={() => handleEditData(e.id)}
        >
          <button className="header-options">{icons.MENU_ICON}</button>
        </GridOptions>
      ),
    },
    { field: 'ime', headerName: t('firstName'), width: 130 },
    { field: 'prezime', headerName: t('lastName'), width: 130 },
    { field: 'kontaktTelefon', headerName: t('telephoneNumber'), width: 150 },
    { field: 'korisnickoIme', headerName: t('userName'), width: 150 },
    { field: 'email', headerName: 'Email', width: 270 },

    ...(idFirme === '1'
      ? [{ field: 'nazivKupca', headerName: t('client'), width: 300 }]
      : []),
    { field: 'nadleznost', headerName: t('responsibility'), width: 150 },
    {
      field: 'tehnickoLice',
      headerName: t('technicalPerson'),
      width: 100,
      renderCell: (e) => (
        <div style={{ textAlign: 'center', width: '100%' }}>
          <CheckBox style={{ height: '36px' }} checked={e.row.tehnickoLice} />
        </div>
      ),
    },
    {
      field: 'administrator',
      headerName: t('adminisistrator'),
      width: 100,
      renderCell: (e) => (
        <div style={{ textAlign: 'center', width: '100%' }}>
          <CheckBox style={{ height: '36px' }} checked={e.row.administrator} />
        </div>
      ),
    },

    {
      field: 'kontaktOsoba',
      headerName: t('contactPerson'),
      hide: idKlijenta,
      width: 120,
      renderCell: (e) => (
        <div style={{ textAlign: 'center', width: '100%' }}>
          <CheckBox style={{ height: '36px' }} checked={e.row.kontaktOsoba} />
        </div>
      ),
    },
    {
      field: 'ucestvujeUChatu',
      headerName: t('ucestvujeUChatu'),
      width: 120,
      renderCell: (e) => (
        <div style={{ textAlign: 'center', width: '100%' }}>
          <CheckBox
            style={{ height: '36px' }}
            checked={e.row.ucestvujeUChatu}
          />
        </div>
      ),
    },
    { field: 'napomena', headerName: t('note'), width: 200 },
  ];

  return (
    <div style={{ height: '58vh', width: '99%' }}>
      <MuiGrid
        data={data}
        columns={columns}
        loading={isLoading}
        columnVisibilityModel={{
          kontaktOsoba: idKlijenta === null,
        }}
      />
    </div>
  );
};

GridProvider.propTypes = {
  data: PropTypes.array.isRequired,
  handleOpenDeleteDialog: PropTypes.func.isRequired,
  handleEditData: PropTypes.func.isRequired,
};

export default GridProvider;
